/* Publish by EComposer at 2025-08-01 19:29:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y5qfs08b1w"]=  window.__ectimmers["ecom-y5qfs08b1w"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-y5qfs08b1w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y5qfs08b1w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bezcepjqlx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bezcepjqlx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l5i8lllbiw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l5i8lllbiw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnirg6brd4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnirg6brd4n', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jq7p91z498"]=  window.__ectimmers["ecom-jq7p91z498"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-jq7p91z498"]["gl93bzk5j"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-jq7p91z498').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jq7p91z498', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htui5zo4j69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htui5zo4j69', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7zgjcpe0qxf"]=  window.__ectimmers["ecom-7zgjcpe0qxf"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-7zgjcpe0qxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zgjcpe0qxf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cg0puxkqi4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cg0puxkqi4k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g48f4f8kol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g48f4f8kol', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2sl292nt5xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2sl292nt5xj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv1xwq94pu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv1xwq94pu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7j2xivptq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7j2xivptq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}